module.exports = __webpack_public_path__ + "static/img/3areaB_13.ca7ac81.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_13.png
// module id = 1164
// module chunks = 1